<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { cleanupTelemetry, initializeTelemetry } from "./telemetry";
  import { startStorageMetrics, cleanupStorageMetrics } from "./storageMetrics";
  import { startHeartbeat, cleanupHeartbeat } from "./heartbeat";

  type Props = {
    displayId: string;
  };
  const { displayId }: Props = $props();

  onMount(() => {
    initializeTelemetry(displayId);
    startHeartbeat();
    startStorageMetrics();
  });

  onDestroy(() => {
    cleanupHeartbeat();
    cleanupStorageMetrics();
    cleanupTelemetry();
  });
</script>
